/*

sohel  10/15/2022  2699761741   Triggers ->Added Code Comments.
Rohini  10/27/2022  2699761741   Triggers ->removed the classname
Raghu 10/28/2022 2699761741  Card Styling Fixes
Prakash 11/22/2022 2699761741 Added card.
Ashraf 12/20/2022 2699761741 fixed user role access

*/

import React, {useEffect, useContext} from 'react';
import {useDispatch} from 'react-redux';
import {ResetStatus as resetStatus} from '../../../../redux/reducers/BRE/AddRuleGroup';
import {
  ResetMessage as resetMessage,
  ResetStatus as resetEventTacticStatus,
} from '../../../../redux/reducers/EventTactics/EventTactics';
import SearchEventTacticContainer from './SearchEventTacticContainer';
import {ThemeContext} from '../../../../themes/ThemeProvider';

function SearchEventTactics({setValue, value, setEventTacticCode, setTriggerMaintenanceData = ()=>{}, roleDataEvent, isCopyIcon, setIsCopyIcon, setRowSelected}) {
  const {reusableInputStyles} = useContext(ThemeContext);

  const classes = reusableInputStyles();
  const dispatch = useDispatch();

  // If Search Trigger tab reset data(2699761741)
  useEffect(() => {
    setRowSelected && setRowSelected(false);
    if (value === 0) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
      dispatch(resetStatus());
      dispatch(resetEventTacticStatus());
    }
  }, [value]);

  return (
    <div>
      <div className={`${classes.cardStyleWhite}`} >
        <SearchEventTacticContainer setRowSelected={setRowSelected} roleDataEvent={roleDataEvent} setValue={setValue} 
          setEventTacticCode={setEventTacticCode} isCopyIcon={isCopyIcon} setIsCopyIcon={setIsCopyIcon} setTriggerMaintenanceData={setTriggerMaintenanceData} />
      </div>
    </div>
  );
}

export default SearchEventTactics;
